export const SET_AUTHENTICATION_STATE = 'SET_AUTHENTICATION_STATE'

export const setAuthenticationState = profile => dispatch =>
  dispatch({ type: SET_AUTHENTICATION_STATE, profile })
